'use strict';
const _ = require('underscore');

class StateType {
    static get name() {
        return null;
    }
}

class Initial extends StateType {
    static get name() {
        return 'initial';
    }
}

class Normal extends StateType {
    static get name() {
        return 'normal';
    }
}

class Final extends StateType {
    static get name() {
        return 'final';
    }
}

class Terminated extends StateType {
    static get name() {
        return 'terminated';
    }
}

class Reject extends StateType {
    static get name() {
        return 'reject';
    }
}

const states = [Initial, Normal, Final, Terminated, Reject];
const stateNameTypes = _.object(_.map(states, s => [s.name, s]));

module.exports = {
    get: function(typeName) {
        if(!(typeName in stateNameTypes)) {
            throw `No such State Type: ${typeName}`;
        }

        return stateNameTypes[typeName];
    },

    types: stateNameTypes
};



// WEBPACK FOOTER //
// ./process/domain/entity/state-type.js